export const PREVIEW_TABLE = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
} as const;

export type TPreviewTable = (typeof PREVIEW_TABLE)[keyof typeof PREVIEW_TABLE];
